import {DefaultSchema} from '@/schema/DefaultSchema'
import {FieldSet} from '@simpli/meta-schema'
import {IUserCollectionResourcesHolder} from '@/model/collection/UserCollection'
import {User} from '@/model/resource/User'

export class FilterUserSchema extends DefaultSchema
  implements IUserCollectionResourcesHolder {
  readonly name = 'FilterUser'

  readonly fieldSet: FieldSet<User> = {}
}
